import { render } from "./SummaryValue.vue?vue&type=template&id=9d915b9e"
import script from "./SummaryValue.vue?vue&type=script&lang=js"
export * from "./SummaryValue.vue?vue&type=script&lang=js"

import "./SummaryValue.vue?vue&type=style&index=0&id=9d915b9e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__